module.exports = __webpack_public_path__ + "assets/bmc.f9993609.svg";